import React from 'react';
import { withRouter } from 'react-router'
import Layout from './Layout';
import './ItemLine.scss';

class ItemLine extends Layout {

  onClick(evt) {
    if (this.props.onClick) {
      this.props.onClick(evt, this.props.history);
    }
  }

  render() {
    let children = this.props.children;
    children = Array.isArray(children) ? children : [children];
    let className = this.props.className || "";
    return (
      <div className={`ItemLine Line ${className}`} data-values={children.length} onClick={(evt)=>{this.onClick(evt)}} data-clickable={this.props.onClick != undefined} data-status={this.props.status} data-creating={this.props.creating}>
        {children.map((child, index)=>{
          return (
            <div className={`Value Value${index+1}`} key={`value${index}`}>
              {child}
            </div>
          )
        })}
      </div>
    );
  }
}

export default withRouter(ItemLine);
